import React from 'react';
import { useNavigate } from 'react-router-dom'; // Importa o hook useNavigate
import BaseLayout from 'pages/_layouts/base';

import { Container } from './styles';
import Button from 'pages/components/Button';

export default function ErrorPage() {
  const navigate = useNavigate(); // Inicializa o hook useNavigate

  return (
    <BaseLayout>
      <Container>
        <div className="error-code">404</div>
        <h1>404</h1>
        <h2>Página não encontrada</h2>

        <Button onClick={() => navigate('/')} color="primary">
          {' '}
          {/* Usa navigate ao invés de history.push */}
          Voltar para Home
        </Button>
      </Container>
    </BaseLayout>
  );
}
